import {
  DataBridgeVersion,
  MenuSpecificRemoteComponent,
  ModuleRegistryEntry,
  RemoteBoundaryComponent,
} from '@dutchiesdk/ecommerce-extensions-sdk';

type ValidatableRemoteComponent = Exclude<ModuleRegistryEntry, MenuSpecificRemoteComponent> | RemoteBoundaryComponent;

const getMajorVersion = (version: string): number => {
  const majorVersionMatch = /^(\d+)/.exec(version);
  return majorVersionMatch ? parseInt(majorVersionMatch[1], 10) : 0;
};

export const remoteComponentIsValid = <T extends ValidatableRemoteComponent = RemoteBoundaryComponent>(
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Component?: T | undefined
): Component is T => {
  if (!Component) {
    return false;
  }

  const componentMajorVersion = getMajorVersion(Component.DataBridgeVersion);
  const hostMajorVersion = getMajorVersion(DataBridgeVersion);

  if (componentMajorVersion !== hostMajorVersion) {
    console.warn(
      `Remote component (${Component.name} v${Component.DataBridgeVersion}) is not compatible with Dutchie Commerce Components data bridge host version: ${DataBridgeVersion}`
    );
    return false;
  }
  return true;
};
